import React, { Component } from 'react';
import classnames from 'classnames';

import sharedStyles from '../sharedStyles.scss';

class ContentOutline extends Component {
  render() {
    const { title, children } = this.props;

    return (
      <div className={classnames(sharedStyles.childLayout, sharedStyles.textBlock)}>
        <div className={sharedStyles.header}>{title}</div>
        <div className={sharedStyles.textBlockChildren}>{children}</div>
      </div>
    );
  }
}

export default ContentOutline;
